import ResponseModal from "../../../global/ResponseModal";

export default function SuccessModal({ title, desc, open, setOpen, onClose }) {
  return (
    <ResponseModal
      title={title}
      description={desc}
      openBool={open}
      setOpenBool={setOpen}
      handleCloseFunc={onClose}
    />
  );
}
